<div class="highlight-solution">
    <dl>
        <dt *ngIf="data.image">
            <a href="/smart-cities-solutions/{{data.id}}">
                <img [src]="data.image">
            </a>
        </dt>
        <dd>
            <h4 [class.noimage]="!data.image">
                <a href="/smart-cities-solutions/{{data.id}}">{{data.title}}</a>
            </h4>
            <h5 *ngIf="data.supplier.id">
                <a href="/smart-cities-suppliers/{{data.supplier.id}}">{{data.supplier.title}}</a>
            </h5>
            <p *ngIf="data.excerpt">
                <a href="/smart-cities-solutions/{{data.id}}">{{limit(data.excerpt)}}</a>
            </p>
        </dd>
    </dl>
</div>